<script setup lang="ts">
defineProps<{
  icon: string
  emptyText: string
}>()

const { t } = useI18n()
const slots = useSlots()
</script>

<template>
  <div class="payment-info" :class="{ 'payment-info--empty': !slots.content }">
    <template v-if="slots.content">
      <v-icon size="24" color="black" class="mr-6">{{ icon }}</v-icon>
      <div class="payment-info__item">
        <div>
          <slot name="content" />
        </div>
        <v-icon size="24" color="success" class="align-self-center">custom:checkmark_big_circle</v-icon>
      </div>
    </template>
    <template v-else>
      <v-icon size="24" color="blue" class="mr-6">{{ icon }}</v-icon>
      <div class="payment-info__item">
        <p class="text-blue">{{ emptyText }}</p>
        <p class="payment-info__warning">{{ t('global.required') }}</p>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.payment-info {
  display: flex;
  color: $c-black;
  padding: 5 * $bw 6 * $bw 5 * $bw 10 * $bw;
  margin-top: 6 * $bw;
  border-radius: 8px;
  border: 1px solid $c-border-2;
  font-size: 15px;
  align-items: start;
  &--empty {
    background-color: $c-grey-light-3;
    align-items: center;

    &:hover {
      background-color: $c-grey-bg;
    }
  }

  &__item {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &:hover {
    cursor: pointer;
    background-color: $c-blue-light-3;
    transition: background-color 0.3s ease;
  }

  &__warning {
    color: $c-danger;
    font-size: 14px;
  }
}
</style>
